/*
 * DIMANDA — otimizações de INP (parte 2/2)
 * Carregado com defer DEPOIS do theme.min.js (ver layout/theme.liquid).
 *
 * O que faz:
 *  1. Seletores de cor/kit (updateAirSelection, updateFlowSelection,
 *     updateFlow2Selection, ...): marca o botão ativo no 1.º frame e corre
 *     o trabalho pesado (troca de variante, imagens, evento "change") só
 *     depois do paint. Antes de qualquer "Adicionar ao Carrinho" o trabalho
 *     pendente é aplicado, para nunca ir a variante errada.
 *  2. "Adicionar ao Carrinho": estado de loading logo na fase de captura.
 *  3. Tema Motion: tira os reflows forçados do prepareTransition (drawer do
 *     carrinho, acordeões, modais), adia o trapFocus e o AOS.refreshHard.
 *  4. Vídeos em autoplay só tocam quando estão visíveis; animações CSS
 *     infinitas (marquees) pausam fora do ecrã; fotos do marquee UGC
 *     passam a ser pedidas a 480 px em vez do tamanho original.
 *
 * Para desligar tudo: remover a linha do dmd-inp.js no layout/theme.liquid.
 */
(function () {
  'use strict';
  if (window.__dmdInp) return;
  window.__dmdInp = true;

  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (cb) { return setTimeout(cb, 16); };

  /* Corre fn depois do próximo paint (o browser pinta o clique primeiro).
     Rede de segurança de 120 ms para quando não há frames (aba escondida). */
  function afterPaint(fn) {
    var done = false;
    function run() {
      if (done) return;
      done = true;
      fn();
    }
    raf(function () { setTimeout(run, 0); });
    setTimeout(run, 120);
  }
  function whenIdle(fn, timeout) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: timeout || 1000 });
    else setTimeout(fn, 200);
  }
  window.dmdAfterPaint = afterPaint;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ------------------------------------------------------------------ */
  /* 1. Seletores de cor / kit                                           */
  /* ------------------------------------------------------------------ */
  var pendingSelection = [];

  function flushSelection() {
    var queue = pendingSelection;
    pendingSelection = [];
    for (var i = 0; i < queue.length; i++) {
      try { queue[i](); } catch (e) { console.error('[dmd-inp]', e); }
    }
  }

  // Feedback imediato: mesma lógica dos scripts originais (classe "active"
  // no elemento clicado, removida dos irmãos com a mesma classe base).
  function markActive(el) {
    if (!el || !el.classList || !el.parentElement) return;
    var base = el.classList[0];
    if (!base) return;
    var siblings = el.parentElement.children;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== el && siblings[i].classList.contains(base)) siblings[i].classList.remove('active');
    }
    el.classList.add('active');
  }

  function wrapSelectionFunctions() {
    Object.keys(window).forEach(function (name) {
      if (!/^update[A-Za-z0-9]*Selection$/.test(name)) return;
      var original = window[name];
      if (typeof original !== 'function' || original.__dmdWrapped) return;

      var wrapped = function (el) {
        var ctx = this;
        var args = arguments;
        try { markActive(el); } catch (e) {}
        pendingSelection.push(function () { original.apply(ctx, args); });
        if (pendingSelection.length === 1) afterPaint(flushSelection);
      };
      wrapped.__dmdWrapped = true;
      wrapped.__dmdOriginal = original;
      window[name] = wrapped;
    });
  }

  wrapSelectionFunctions();
  onReady(wrapSelectionFunctions);

  // Garante que a variante escolhida já está aplicada antes de adicionar ao carrinho.
  document.addEventListener('click', function (e) {
    if (!pendingSelection.length) return;
    var t = e.target;
    if (t && t.closest && t.closest('button[type="submit"], [name="add"], .add-to-cart, #sticky-atc-btn')) flushSelection();
  }, true);

  document.addEventListener('submit', function (e) {
    if (pendingSelection.length) flushSelection();

    /* 2. Loading imediato no botão de compra (antes de qualquer outro listener). */
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      var btn = form.querySelector('.add-to-cart, [name="add"]');
      if (btn) btn.classList.add('btn--loading');
    }
  }, true);

  /* ------------------------------------------------------------------ */
  /* 3. Patches ao tema Motion                                           */
  /* ------------------------------------------------------------------ */
  function patchTheme() {
    var theme = window.theme;
    if (!theme || theme.__dmdInpPatched) return;
    theme.__dmdInpPatched = true;

    // 3a. prepareTransition: o original lia el.offsetWidth (layout síncrono da
    // página inteira) a cada abrir/fechar de drawer, acordeão ou modal.
    // Para a transição arrancar basta um flush de ESTILO (sem layout).
    if (theme.utils && typeof theme.utils.prepareTransition === 'function') {
      theme.utils.prepareTransition = function (el, callback) {
        if (!el) {
          if (typeof callback === 'function') callback();
          return;
        }
        el.addEventListener('transitionend', function removeClass() {
          el.classList.remove('is-transitioning');
          el.removeEventListener('transitionend', removeClass);
        });
        el.classList.add('is-transitioning');
        void window.getComputedStyle(el).opacity;
        if (typeof callback === 'function') callback();
      };
    }

    // 3b. trapFocus: filtrava os elementos focáveis com offsetParent (layout
    // forçado) e fazia focus() dentro do clique. Passa para depois do paint.
    if (theme.a11y && typeof theme.a11y.trapFocus === 'function') {
      var originalTrap = theme.a11y.trapFocus;
      var originalRemove = theme.a11y.removeTrapFocus;
      var trapTokens = {};

      theme.a11y.trapFocus = function (options) {
        var ns = (options && options.namespace) || '_default';
        var token = {};
        trapTokens[ns] = token;
        var ctx = this;
        var args = arguments;
        afterPaint(function () {
          if (trapTokens[ns] === token) originalTrap.apply(ctx, args);
        });
      };

      if (typeof originalRemove === 'function') {
        theme.a11y.removeTrapFocus = function (options) {
          var ns = (options && options.namespace) || '_default';
          trapTokens[ns] = null;
          return originalRemove.apply(this, arguments);
        };
      }
    }
  }

  // 3c. AOS.refreshHard (chamado em cada rebuild do carrinho) recalcula
  // posições logo a seguir ao innerHTML -> layout forçado. Passa para idle.
  function patchAOS() {
    var A = window.AOS;
    if (!A || A.__dmdInp || typeof A.refreshHard !== 'function') return;
    var originalRefreshHard = A.refreshHard;
    var queued = false;
    A.refreshHard = function () {
      var ctx = this;
      var args = arguments;
      if (queued) return;
      queued = true;
      whenIdle(function () {
        queued = false;
        originalRefreshHard.apply(ctx, args);
      }, 800);
    };
    A.__dmdInp = true;
  }

  patchTheme();
  patchAOS();
  onReady(function () { patchTheme(); patchAOS(); });
  window.addEventListener('load', patchAOS);

  /* ------------------------------------------------------------------ */
  /* 4. Vídeos, animações infinitas e imagens do marquee                 */
  /* ------------------------------------------------------------------ */
  if (!('IntersectionObserver' in window)) return;

  var governedVideos = [];

  function syncVideo(v) {
    if (v.__dmdVisible && !document.hidden) {
      if (v.paused) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    } else if (!v.paused) {
      v.pause();
    }
  }

  var videoObserver = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      entries[i].target.__dmdVisible = entries[i].isIntersecting;
      syncVideo(entries[i].target);
    }
  }, { rootMargin: '200px 120px' });

  function governVideo(v) {
    if (!v || v.__dmdGoverned) return;
    var isAutoplay = v.autoplay || v.hasAttribute('autoplay');
    var isMuted = v.muted || v.hasAttribute('muted');
    // Só vídeos decorativos (autoplay + sem som). Vídeos com controlos/som ficam como estão.
    if (!isAutoplay || !isMuted || v.hasAttribute('data-dmd-keep-autoplay')) return;
    v.__dmdGoverned = true;
    v.__dmdVisible = false;
    v.autoplay = false;
    governedVideos.push(v);
    videoObserver.observe(v); // o 1.º callback volta a pôr a tocar se estiver visível
  }

  function governVideosIn(root) {
    if (!root) return;
    if (root.tagName === 'VIDEO') { governVideo(root); return; }
    if (!root.getElementsByTagName) return;
    var list = root.getElementsByTagName('video');
    for (var i = 0; i < list.length; i++) governVideo(list[i]);
  }

  document.addEventListener('visibilitychange', function () {
    for (var i = 0; i < governedVideos.length; i++) syncVideo(governedVideos[i]);
  });

  // Animações CSS infinitas (marquee do header, marquee UGC, spinners) pausam fora do ecrã.
  var styleEl = document.createElement('style');
  styleEl.textContent = '.dmd-anim-offscreen,.dmd-anim-offscreen *{animation-play-state:paused!important}';
  document.head.appendChild(styleEl);

  var animationObserver = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      entries[i].target.classList.toggle('dmd-anim-offscreen', !entries[i].isIntersecting);
    }
  }, { rootMargin: '150px 0px' });

  var observedAnimTargets = typeof WeakSet === 'function' ? new WeakSet() : null;

  function governAnimations() {
    if (!document.getAnimations || !observedAnimTargets) return;
    var animations = document.getAnimations();
    for (var i = 0; i < animations.length; i++) {
      var a = animations[i];
      if (!(window.CSSAnimation && a instanceof window.CSSAnimation)) continue;
      var effect = a.effect;
      var target = effect && effect.target;
      if (!target || target.nodeType !== 1 || observedAnimTargets.has(target)) continue;
      if (!effect.getTiming || effect.getTiming().iterations !== Infinity) continue;
      observedAnimTargets.add(target);
      animationObserver.observe(target);
    }
  }

  // Fotos do marquee UGC: eram pedidas no tamanho original (milhares de px).
  function shrinkMarqueeImages() {
    var imgs = document.querySelectorAll('.du-track img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth) continue;
      var src = img.getAttribute('src') || '';
      if (!/\/\/cdn\.shopify\.com\/s\/files\//.test(src)) continue;
      if (/[?&]width=/.test(src) || /\.(heic|gif|svg)(\?|$)/i.test(src)) continue;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=480';
    }
  }

  function initMedia() {
    governVideosIn(document.body);
    shrinkMarqueeImages();
    governAnimations();

    // Vídeos adicionados mais tarde (secções dinâmicas, apps).
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) governVideosIn(added[j]);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  onReady(initMedia);
  // Animações que só arrancam depois (secções que aparecem com scroll, etc.).
  window.addEventListener('load', function () {
    whenIdle(governAnimations, 2000);
    setTimeout(function () { whenIdle(governAnimations, 2000); }, 4000);
  });
})();